module.exports = {
  customer: 'ealing',
  environment: 'uat',
  isBetterCare: true,
  yourMoney: false,
  jobsVolunteering: false,
  googleAnalyticsId: false,
  robots: false,
  chatWidget: false,
  requirePostcode: false,

  app: {
    home: 'https://ealing2.bettercare.org.uk'
  },
  serverBaseUrl: 'https://api-ealing-2.bettercare.org.uk',
  api: {
    baseUrl: 'https://api-ealing-2.bettercare.org.uk/internal/v1'
  },
  authGateway: 'https://account2.ealing.bettercare.org.uk',
  loginServices: [
    {name: 'kerp'},
    {name: 'phone'},
    {name: 'google', postLogoutUrl: 'https://accounts.google.com/Logout'},
    {name: 'facebook'},
    {name: 'agent'},
    {name: 'referenceNumber'}
  ],
  ui: {
    showJobSearchJournal: false,
    showOfflineForms: true,
    showTestingTools: true,
    showDraftForms: true,
    showAssessmentMutators: false,
    restrictions: {
      applications: false
    }
  },
  airbrake: {
    enabled: true,
    projectId: 131082,
    projectKey: 'facc9a060872b357453b677f15d319e3'
  }
};
